(function () {
    'use strict';
    $(document).ready(function () {

        // Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        //Clicked outside of element
        window.clickedOutside = function (targetToClose, callback, _excludes = []) {
            const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
            const $target = $(targetToClose);

            if (typeof callback !== "function") {
                console.error('Callback has to be a function!');
                return null;
            }

            $('body').on('click', function (e) {
                const clickedElement = e.target;
                const isTargetVisible = $target.css('display') !== 'none';
                const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
                const isClickedElementTarget = $target.is(clickedElement);
                const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

                if (
                    isTargetVisible &&
                    !isClickedElementExcluded &&
                    !isClickedElementTarget &&
                    isClickedElementATargetChild
                ) {
                    callback($target, excludes);
                }
            });
        }
        //Go top
        $('footer .go-top').click(function () {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            return false;
        });

        const fontSizeType = {
            min: 'min',
            normal: 'normal',
            max: 'max'
        };

        let actualFontSizeType = fontSizeType.normal;

        const setFontSize = (type, setLocalStorage) => {
            const size = fontSizeType[type];

            $('html').attr('data-font-size', size);

            if (setLocalStorage)
                localStorage.setItem('font-size', type);
        }
        
        // Handle font size
        if (localStorage.getItem('font-size')) {
            actualFontSizeType = localStorage.getItem('font-size');
        }
        setFontSize(actualFontSizeType, false);

        // events
        $('.font-trigger').on('click', function (e) {
            if (actualFontSizeType === fontSizeType.normal)
                actualFontSizeType = fontSizeType.max;
            else if (actualFontSizeType === fontSizeType.max)
                actualFontSizeType = fontSizeType.min;
            else if (actualFontSizeType === fontSizeType.min)
                actualFontSizeType = fontSizeType.normal;

            setFontSize(actualFontSizeType, true);
            e.preventDefault();
            return false;
        });

        // Handle contrast
        if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
            $('.contrast-trigger').addClass('active');
            $('body').addClass('contrast');
        }

        // events
        $('.contrast-trigger').on('click', function (e) {
            if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
                localStorage.setItem('contrast', 'off');
                $('.contrast-trigger').removeClass('active');
            } else {
                localStorage.setItem('contrast', 'on');
                $('.contrast-trigger').addClass('active');
            }
            $('body').toggleClass('contrast');
            e.preventDefault();
            return false;
        });

        // Object fit IE11 polyfill
        objectFitImages();
    });
}(jQuery));
